import { render, staticRenderFns } from "./costList.vue?vue&type=template&id=393f0ed0&scoped=true&"
import script from "./costList.vue?vue&type=script&lang=js&"
export * from "./costList.vue?vue&type=script&lang=js&"
import style0 from "./costList.vue?vue&type=style&index=0&id=393f0ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f0ed0",
  null
  
)

export default component.exports